export default "__VITE_ASSET__7cDZV6LX__"